 import Vue from 'vue'
import Vuex from 'vuex'

import {  login, phoneLogin,logout, updateUserInfo ,getUserInfo} from '@/api/modules/user'
import { ACCESS_TOKEN, USER_NAME, USER_INFO,Cache } from "@/store/mutation-types"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    username: '',
    isMobile: false,
    conventionId:'0',
    conventionTitle:'',
    token:''
  },
  mutations: {
    setConventionId(state,conventionId){
      state.conventionId = conventionId
    },
    setUsername(state, username) {
      state.username = username
    },
  
    setToken(state,token){
      state.token = token
    },
    setConventionTitle(state,conventionTitle){
      state.conventionTitle = conventionTitle
    },
   
    setUser(state, user) {
      state.user = user
    },
    SET_MOBILE(state, isMobile) {
      state.isMobile = isMobile
    },
    clearUser(state) {
      state.user = null
      state.username = null
    }
  },
  actions: {
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        console.log(userInfo)
        login(userInfo.username,userInfo.password).then(response => {
          if (response.code == '200') {
            const result = response.result
            const userInfo = result.userInfo
            Cache.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Cache.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Cache.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            commit('setToken', result.token)
            commit('setUser', userInfo)
            commit('setUsername', userInfo.username)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetUserInfo({ commit,state }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          if (response.code == '200') {
            const result = response.result
            const userInfo = result
            Cache.set(ACCESS_TOKEN, Cache.get(ACCESS_TOKEN), 7 * 24 * 60 * 60 * 1000)
            Cache.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Cache.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            commit('setToken', Cache.get(ACCESS_TOKEN))
            commit('setUser', userInfo)
            commit('setUsername', userInfo.username)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateUserInfo({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        updateUserInfo(userInfo).then(response => {
          if (response.code == '200') {
            Cache.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Cache.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            commit('setUser', userInfo)
            commit('setUsername', userInfo.username)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //手机号登录
    PhoneLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        phoneLogin(userInfo.phone,userInfo.code).then(response => {
          if (response.code == '200') {
            const result = response.result
            const userInfo = result.userInfo
             Cache.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Cache.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Cache.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            commit('setToken', result.token)
            commit('setUser', userInfo)
            commit('setUsername', userInfo.username)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        let logoutToken = state.token;
        commit('setToken', '')
        commit('clearUser')
        commit('setUsername', '')
        localStorage.removeItem(ACCESS_TOKEN)
        localStorage.removeItem(USER_INFO)
        localStorage.removeItem(USER_NAME)
        logout(logoutToken).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    },
  }
})